<template>
  <ion-page id="ai-chat">

    <AlertReplacement :alertInfo="alertInfo" :trigger="alertTrigger"
            @alert-result="alertResult"></AlertReplacement>

    <ion-content>

      <!-- GENERAL SHARED ROOM SCREEN -->
      <div v-show="showState == SHOW_ROOM">

        <div  id="the_chatwindow" 
                    :style="styleChatWindow" 
                    :class="{ 'text-dark' : isDark, 
                              'text-light' : !isDark, 
                              'chat-window-dark' : isDark,
                              'chat-window-light' : !isDark }">

          <div v-for="item in chatDisplayArray" v-bind:key="item.id">
            <div v-if="item.type == 'welcome'" class="chat-welcome">
              {{ item.text }}
            </div>
            <div v-if="item.type == 'response'" class="chat-bubble"
                    :class="{ 'chat-other-dark' : isDark, 'chat-other-light' : !isDark}">
                    <div v-html="item.html" @click="handleMarkdownClick"></div>
            </div>       
            <div v-if="item.type == 'prompt'" class="chat-bubble"
                    :class="{ 'chat-me-dark' : isDark, 'chat-me-light' : !isDark}">
              {{ item.text }}
            </div>    
          </div>

          <!-- this is the last text that shows in real time -->
          <div v-show="markdownHTML.length > 0" class="chat-bubble"
                :class="{ 'chat-other-dark' : isDark, 
                          'chat-other-light' : !isDark,
                          'chat-last-dark' : isDark, 
                }">
              <div v-html="markdownHTML"  @click="handleMarkdownClick"></div>

          </div>
          <!-- add 0px height invisible element. have program scroll down it to -->
          <div id="bottom-element" class="invisible-bottom-element"></div>
        </div>

        <div id="the_sendwindow" 
                    :style="styleSendText" 
                    :class="{ 'text-dark' : isDark, 'text-light' : !isDark }">
          <ion-item>
      
            <ion-input type="text"  :placeholder="placeholderMessaage" :value="chatMessage"
                    :disabled="markdownHTML.length > 0"
                    @ionInput="chatMessageInputChange" @keyup.enter="sendTypedMessage()">
            </ion-input>
            <ion-buttons slot="end">
              <ion-button  size="small" @click="sendTypedMessage()">
                <ion-icon :icon="sendOutline" slot="icon-only" ></ion-icon>
              </ion-button>
          </ion-buttons>
          
          </ion-item>
        </div>
      </div>

      <ActionSheet heading="Options" :items="actionSheetButtons" 
                  :trigger="actionSheetTrigger"
                  @action-sheet-result="actionSheetResult">
      </ActionSheet>
    </ion-content>
    <Toolbar :elements="toolbarElements" :trigger="toolbarTrigger"        
                        @toolbar-click="toolbarClick"/>
  </ion-page>
</template>

<script setup>

// https://github.com/shanet/WebRTC-Example

// dude works with brad traversy
// https://www.youtube.com/watch?v=QsH8FL0952k
// https://github.com/divanov11/PeerChat

// multiple peer code
// https://github.com/webrtc/samples/blob/gh-pages/src/content/peerconnection/multiple/js/main.js


import { IonCheckbox, IonIcon, IonGrid,IonRow,IonCol,IonButton,IonButtons,IonItem,IonInput,IonPage, IonContent, modalController } from '@ionic/vue';

import { arrowUndoOutline,brushOutline, colorPaletteOutline, swapVerticalOutline, arrowBackOutline,arrowForwardOutline,arrowUpOutline, caretBackOutline,caretForwardOutline,micOutline, micOffOutline, sendOutline, timer} from 'ionicons/icons';

import { Chess, validateFen } from '@/ts/chess.ts'
import { buildPieceLocationStrings, getPieceSetName , columnToNumber, buildAvailableMoves,
  listOfSquaresWithNewPieces, buildCastleString } from '@/composables/blindfoldSupport.js'

import { ref, watch , onMounted, onBeforeUnmount, onUnmounted, createElementBlock } from 'vue';
import ModalLearnPreferences from '@/components/ModalLearnPreferences.vue'
import ModalErrorMessage from '@/components/ModalErrorMessage.vue'
import CMChessboard from '@/components/CMChessboard.vue'
import AlertReplacement from '@/components/AlertReplacement.vue'
import ActionSheet from '@/components/ActionSheet.vue'
import ModalGenericMultiList from '@/components/ModalGenericMultiList.vue'

import Toolbar from '@/components/Toolbar.vue';

import { findToolbarElement, setToolbarElementDisabledFlag, 
                  setToolbarElementLabel, setAllToolbarElementsDisabled, restoreAllToolbarElementsDisabled} 
              from '@/composables/toolbarSupport.js'

import { getWebSiteURL, useGetData , getLichessData, generateErrorAlertText } from '@/composables/getData.js'

import { useConnectionStore } from '@/stores/connectionStore';
import { useWindowSizeStore } from '@/stores/windowSizeStore';
import { doStartupCheck } from '@/composables/startupCheck.js'
import { availableWidthHeight, calculateChessBoardRect, isScreenPortraitOrientation } 
            from '@/composables/screenSize'

import MarkdownIt from "markdown-it";

const md = new MarkdownIt({
  html: true,
  linkify: true,
  typographer: true
});

var sessionID = 0
var generatedID = ""

const MOVEHISTORY_FONTSIZE = 16
const MOVEHISTORY_HEIGHT =  MOVEHISTORY_FONTSIZE * 1.2 + 4

var chess = new Chess()

const connectionStore = useConnectionStore()

const isDark = ref(connectionStore.getDarkmode != "light")

//console.log("COACH ",isCoach)

const menuTrigger = ref(0)

const TOOLBAR_DONE = 0
const toolbarTrigger = ref(0)

const windowSizeStore = useWindowSizeStore()
const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] })

const chatMessage = ref("")
const placeholderMessaage = ref("Enter Chat Message")

// this will uniquely ID the connection for Peer-to-Peer stuff
const myUUID = connectionStore.getSessionUUID
//console.log("MY UUID",myUUID)

const initialChatDisplay =   { id : 1, name : "", type : "response", 
        html : "Let's Talk Chess! Don't forget, I'm not human and can make mistakes." } 
initialChatDisplay.text = initialChatDisplay.html

const chatDisplayArray = ref([initialChatDisplay])
var markdownText = ""
const markdownHTML = ref(md.render(markdownText))

// fens from the response that can be copied to the clipboard
var fenArray = []

var isPortrait = true

const alertInfo = ref({})
const alertTrigger = ref(0)

const SHOW_ROOM = 1
const showState = ref(SHOW_ROOM)

const TOOLBAR_BUILD_FEN = 30
const TOOLBAR_BUILD_WHO_MOVE = 31
const TOOLBAR_BUILD_PGN = 32
const TOOLBAR_BUILD_DONE = 33
const TOOLBAR_BUILD_DONE_FROM_PGN = 39

const toolbarBuildBoardElements = [
{ index : TOOLBAR_BUILD_FEN, label : "Board Source" , disabled : false, collapse:false},
{ index : TOOLBAR_BUILD_WHO_MOVE, label : "White To Move" , disabled : false, collapse:false},
{ index : TOOLBAR_BUILD_PGN, label : "Paste Game" , disabled : false, collapse:false},
{ index : TOOLBAR_BUILD_DONE, label : "Done" , disabled : false, collapse:false},
]

const TOOLBAR_MAIN_BACK = 0
const TOOLBAR_MAIN_FORWARD = 1
const TOOLBAR_MAIN_MARKUP = 2
const TOOLBAR_MAIN_BACK_TO_GAME = 3
const TOOLBAR_MAIN_COACH = 4
const TOOLBAR_MAIN_STUDENT = 5

const toolbarMainElements = [
{ index : TOOLBAR_MAIN_MARKUP, label : "Button TBD" , disabled : true, collapse:false},
{ index : TOOLBAR_MAIN_BACK_TO_GAME, label : "TBD" , disabled : true, collapse:false},
]

const toolbarElements = ref(toolbarMainElements)

const actionSheetTrigger = ref(0)
const ACTION_COACH_OPTION_INDEX = 10
const ACTION_COACH_OPTION_SESSION_TIMER = 10
const ACTION_COACH_OPTION_LEAVE_ROOM = 11
const ACTION_COACH_OPTION_ENGINE = 12
const ACTION_COACH_OPTION_SOUNDS = 13
const ACTION_COACH_OPTION_COPY = 14
const ACTION_COACH_OPTION_BUILD_BOARD = 15
const ACTION_COACH_OPTION_FLIP_BOARD = 16

var coachActionSheetButtons = [
    { text: "Start Session Timer", data: { index: ACTION_COACH_OPTION_SESSION_TIMER } },
    { text: "Leave Room", data: { index: ACTION_COACH_OPTION_LEAVE_ROOM } },
    { text: "Enable Engine Scores", data: { index: ACTION_COACH_OPTION_ENGINE } },
    { text: "Mute Sounds", data: { index: ACTION_COACH_OPTION_SOUNDS } },
    { text: "Copy to Clipboard", data: { index: ACTION_COACH_OPTION_COPY } },
    { text: "Set Up Board", data: { index: ACTION_COACH_OPTION_BUILD_BOARD } },
    { text: "Flip Board", data: { index: ACTION_COACH_OPTION_FLIP_BOARD } },

    { text: 'Cancel', role: 'cancel',data: { index : -1}}
  ]

const ACTION_STUDENT_OPTION_INDEX = 20
const ACTION_STUDENT_OPTION_SESSION_TIMER = 20
const ACTION_STUDENT_OPTION_LEAVE_ROOM = 21
const ACTION_STUDENT_OPTION_SOUNDS = 22
const ACTION_STUDENT_OPTION_COPY = 23
const ACTION_STUDENT_OPTION_BUILD_BOARD = 24
const ACTION_STUDENT_OPTION_FLIP_BOARD = 25

const actionSheetButtons = ref([])

const styleOneFrame = ref({
   position : "absolute",
   "overflow-y" : "scroll",
   top : "0px",
   left : "100px",
   width: "100px",
   height : "100px"
 })

const styleChatWindow = ref({
  position : "absolute",
  "overflow-y" : "scroll",
  top : "0px",
  left : "100px",
  width: "100px",
  height : "100px",
  "margin-bottom" : "0px",
})

const styleSendText = ref({
  position : "absolute",
  "overflow-y" : "scroll",
  top : "0px",
  left : "100px",
  width: "100px",
  height : "100px",
  "text-align" : "center"

})

 //updateWidthHeights()
 doStartupCheck(false,afterStartupCallbackRoutine)


onMounted(() => {
  
})

onBeforeUnmount(() => {

})

onUnmounted(() => {
})

watch(() => windowSizeStore.getWindowSize, () => {
    //console.log('*********** window size changes detected')
    windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
    //console.log("*** logoff new window size",windowSizeRef.value)
    menuTrigger.value++
    updateWidthHeights()
  })

  const openErrorModal = async (programName,errorMessage) => {
    const modal = await modalController.create({
      component: ModalErrorMessage,
      componentProps: {
        type : "commError",
        program : programName ,
        errorMessage : errorMessage
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();
  };

  // ADD Modal
  const learnPreferencesModal = async (action) => {
    const modal = await modalController.create({
      component: ModalLearnPreferences,
      componentProps: {
        action : "add",
        min : 800,
        max : 1200,
        color : "white",
        name : "blah",
        editPercentage : 1
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
    }
      
  };

function afterStartupCallbackRoutine(stuffChanged,errorProgram,errorEntry) {
  if (errorProgram != null)
      openErrorModal(errorProgram,errorEntry)
  menuTrigger.value++
  updateWidthHeights()

  // get the initial welcome to chatbot
  //const webURL = getWebSiteURL()
  //streamWithIterator(webURL + "ai_chat.php","")
}

function updateWidthHeights() {

  const availableSpace = availableWidthHeight()
  const oneframePositionTop = availableSpace.topIndent
  const oneframePositionLeft = availableSpace.leftRightIndent + availableSpace.leftIndent
  const oneframeHeight = availableSpace.height - oneframePositionTop
  const oneframeWidth = availableSpace.width - availableSpace.leftRightIndent * 2

  // used for the connect screen
  styleOneFrame.value.height = oneframeHeight + "px"
  styleOneFrame.value.width = oneframeWidth + "px"
  styleOneFrame.value.top = oneframePositionTop + "px"
  styleOneFrame.value.left = oneframePositionLeft + "px"

  // used for the board & chat
  isPortrait = isScreenPortraitOrientation(availableSpace)
  isPortrait = false
  const boundaries = (isPortrait) ? calculatePortraitWidthHeights(availableSpace) :
                                    calculateLandscapeWidthHeights(availableSpace)
  updateStyleObjects(boundaries)
}

function updateStyleObjects(boundaries) {
  styleChatWindow.value.height = boundaries['chat'].height + "px"
  styleChatWindow.value.width = boundaries['chat'].width + "px"
  styleChatWindow.value.top = boundaries['chat'].top + "px"
  styleChatWindow.value.left = boundaries['chat'].left + "px"

  styleSendText.value.height = boundaries['send'].height + "px"
  styleSendText.value.width = boundaries['send'].width + "px"
  styleSendText.value.top = boundaries['send'].top + "px"
  styleSendText.value.left = boundaries['send'].left + "px"

}

function calculatePortraitWidthHeights(availableSpace) {

  const chatWindowPositionTop = 0
  const chatWindowPositionLeft = availableSpace.left
  const chatWindowHeight = availableSpace.height - chatWindowPositionTop - MOVEHISTORY_HEIGHT * 2.5
  const chatWindowWidth = availableSpace.right - availableSpace.left

  const sendTextPositionTop = chatWindowPositionTop + chatWindowHeight
  const sendTextPositionLeft = chatWindowPositionLeft
  const sendTextHeight = availableSpace.height - sendTextPositionTop
  const sendTextWidth = chatWindowWidth

  const result = { 
    chat : {
      width : chatWindowWidth,
      height : chatWindowHeight,
      left : chatWindowPositionLeft + availableSpace.leftIndent,
      top : chatWindowPositionTop+ availableSpace.topIndent
    },
    send : {
      width : sendTextWidth,
      height : sendTextHeight,
      left : sendTextPositionLeft + availableSpace.leftIndent,
      top : sendTextPositionTop+ availableSpace.topIndent
    },
  }
  return (result)
}

function calculateLandscapeWidthHeights(availableSpace) {

  const chatWindowPositionTop = 0
  const chatWindowPositionLeft = availableSpace.leftRightIndent
  const chatWindowHeight = availableSpace.height - chatWindowPositionTop - MOVEHISTORY_HEIGHT * 2.5
  const chatWindowWidth = availableSpace.width - chatWindowPositionLeft

  const sendTextPositionTop = chatWindowPositionTop + chatWindowHeight
  const sendTextPositionLeft = availableSpace.leftRightIndent
  const sendTextHeight = availableSpace.height - sendTextPositionTop
  const sendTextWidth = availableSpace.width - sendTextPositionLeft

  const result = { 
    chat : {
      width : chatWindowWidth,
      height : chatWindowHeight,
      left : chatWindowPositionLeft + availableSpace.leftIndent,
      top : chatWindowPositionTop+ availableSpace.topIndent
    },
    send : {
      width : sendTextWidth,
      height : sendTextHeight,
      left : sendTextPositionLeft + availableSpace.leftIndent,
      top : sendTextPositionTop+ availableSpace.topIndent
    },
  }
  return (result)
}

  function handleMarkdownClick(event) {
    //console.log("markdown click",event)
    const link = event.target.closest("a");
    if (!link) return;

    const href = link.getAttribute("href");

    // Prevent normal navigation
    event.preventDefault();

    const arrayIndex = parseInt(href.substring(4))
    //console.log("Clicked markdown link:", href,fenArray[arrayIndex]);
    navigator.clipboard.writeText(fenArray[arrayIndex].trim())
  }

function alertResult(response,task,info) {
  console.log("Alert Result",response,task)
}

function chatMessageInputChange(ev) {
  //console.log("*** chat changed", markdownHTML.value.length)
  if (markdownHTML.value.length != 0) {
    chatMessage.value = ""
    return
  }
  const value = ev.target.value;
  chatMessage.value = value.trim()
}

function sendTypedMessage() {
  if (chatMessage.value.length == 0)
    return
  //console.log("CHAT MESSAGE",chatMessage.value)
  const webURL = getWebSiteURL()

  const fen = "8/8/8/8/3k4/8/1PK5/1R6 w - - 0 1"
  const boardSize = 100
  markdownText = ""
  markdownHTML.value = "Thinking..."
  //markdownHTML.value += ' <img width="200" height="200" src="https://rnbqkbnr.com/rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR.png" />'
  placeholderMessaage.value = "Please wait, chatbot responding"
  streamWithIterator(webURL + "ai_chat.php",chatMessage.value)

  chatMessage.value = ""

}


function safeJSONParse(str, fallback = null) {
    try {
        return JSON.parse(str);
    } catch {
        console.log("Parse Failed ->",str)
        return fallback;
    }
}

var controller = null; // We keep this in the outer scope

async function streamWithIterator(url,text) {

  // 2. Initialize a new AbortController for this specific request
  controller = new AbortController();
  const signal = controller.signal;

  // add user's text to chat display
  const yourChat = { id :  chatDisplayArray.value.length+1, name : "", type : "prompt", text : text } 
  chatDisplayArray.value.push(yourChat)  

  const params = new URLSearchParams();
  params.append("session_id",sessionID);
  params.append("text",text);
  //console.log("**** TEXT ",sessionID, text)

  try {
      const response = await fetch(url, {
          method: 'POST',
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          },
          body: params,
          signal: signal // Attach the signal here
      });

      const reader = response.body.getReader();
      const decoder = new TextDecoder();

      while (true) {
          const { value, done } = await reader.read();
          if (done) break;

          const text = decoder.decode(value);
          //console.log("TEXT COMING BACK",text)
          const jsonLines = text.split("\n")
          //console.log("json lines",jsonLines)
          for (var line=0; line < jsonLines.length; line++) {
            const oneLine = jsonLines[line]
            if (oneLine == "")
              continue
            //console.log("TEXT ",oneLine)

            if (oneLine.startsWith('{"text":')) {
              //const json = JSON.parse(jsonLines[line])
              const json = safeJSONParse(jsonLines[line])
              if (json.hasOwnProperty('text')) {
                markdownText += json.text

                // replace pairs of ~ with the image of FEN
                var markdownParts = markdownText.split("~")

                // sometimes it uses a triple backtick and sometimes a single
                if (markdownParts.length == 1)
                  markdownParts = markdownText.split("```")
                if (markdownParts.length == 1)
                  markdownParts = markdownText.split("`")

                // is there a FEN to replace?
                if (markdownParts.length >= 3) {
                  var markdownPatched = ""
                  for (var part=0; part < markdownParts.length; part++) {
                    if ((part % 2) == 1) {
                      if (markdownParts[part].length == 0)
                        continue
                      
                      const fenParts = markdownParts[part].split(" ")
                      markdownParts[part] += '  \n[Copy to Clipboard](#Fen' + fenArray.length + ')  \n'

                      // if the first 4 parts are there, use them otherwise just the first
                      if (fenParts.length >= 4) {
                        const fen = fenParts.slice(0,4).join(" ") + " 0 1"
                        fenArray.push(fen)
                      }
                      else
                        fenArray.push(fenParts[0])

                      markdownParts[part] += ' <img width="250" height="250" src="https://rnbqkbnr.com/' + fenParts[0] + '.png" />  \n'
                      //markdownParts[part] += ' ![Alt text](https://rnbqkbnr.com/rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR.png "a title"){.custom-resize-class} '
                    }
                  }
                  markdownText = markdownParts.join("")
                }
                
                //console.log("Markdowntext",markdownText)
                const displayMarkDownText = markdownText
                markdownHTML.value = md.render(displayMarkDownText)
              }
            }
            else
            if (oneLine.startsWith('{"id":')) {
              //const json = JSON.parse(jsonLines[line])
              const json = safeJSONParse(jsonLines[line])
              if (json.hasOwnProperty('id')) {
                generatedID = json.id
                //console.log("GENERATED ID ",generatedID)
              }
            }
            else
            if (oneLine.startsWith('{"session_id":')) {
              //const json = JSON.parse(jsonLines[line])
              const json = safeJSONParse(jsonLines[line])
              if (json.hasOwnProperty('session_id')) {
                sessionID = json.session_id
                //console.log("SESSION ID ",sessionID)
              }
            }
          }
      }  
      const oneChat = { id : 2, name : "", type : "response", text : markdownText,
                    html : markdownHTML.value
       } 
      chatDisplayArray.value.push(oneChat)  
      markdownHTML.value = ""
      placeholderMessaage.value = "Enter Chat Message"
  } catch (err) {
      if (err.name === 'AbortError') {
            console.log( "\n[Generation stopped by user]")
      } else {
          console.error("Stream error:", err);
      }
  } finally {
      // 3. Reset UI state regardless of success or failure
      controller = null;
  }
  
}

// The Stop Button Logic
    // if (controller) {
    //     controller.abort(); // This triggers the 'AbortError' in the catch block
    // }

// START Generic Options List

const openGenericMultiListModal = async () => {
  var soundOptions = [
      { index : 0, selected : muteMoveSound, name : "Mute Moves", id : "move", radio : "move" },
      { index : 1, selected : muteChatSound, name : "Mute Chat", id : "chat", radio : "chat" }
  ]
    const modal = await modalController.create({
      component: ModalGenericMultiList,
      componentProps: {
        mustHaveLeastOneCheckBox : false,
        displayArray : soundOptions,
        title : soundTitle      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
      //console.log("CONFIRM in multi",data)
      updateMutes(data)
      connectionStore.setRoomSounds(data)
    }
  };
  // END Generic Options List


// stuff for options

// Start ACTION LIST
function actionSheetResult(action,index) {
  if (action != "yes")
    return
  actionClick(index)
}

function setupAlert(header,message,type,task) {
  alertInfo.value = { header : header, message : message, type : type, task : task  }
  alertTrigger.value++
}

function actionClick(index) {
  switch (index) {
    case ACTION_COACH_OPTION_COPY :
    case ACTION_STUDENT_OPTION_COPY :
      break
    case ACTION_COACH_OPTION_SOUNDS :
    case ACTION_STUDENT_OPTION_SOUNDS :
      break
    case ACTION_STUDENT_OPTION_SESSION_TIMER :
      break
    case ACTION_COACH_OPTION_ENGINE :
      break
    case ACTION_COACH_OPTION_SESSION_TIMER :
      break
    case ACTION_COACH_OPTION_LEAVE_ROOM :
    case ACTION_STUDENT_OPTION_LEAVE_ROOM :
      break
    case ACTION_COACH_OPTION_FLIP_BOARD :
    case ACTION_STUDENT_OPTION_FLIP_BOARD :
      break
    case ACTION_COACH_OPTION_BUILD_BOARD:
    case ACTION_STUDENT_OPTION_BUILD_BOARD:
      break
   
  }
}

// END Action List


function toolbarClick(arrayIndex) {
  //console.log("toolbar click",showState,arrayIndex)
}

function scrollToId(id) {
  const yOffset = document.getElementById(id).offsetTop;
  content.value.$el.scrollToPoint(0,yOffset -100 ,200)
}

</script>

<style scoped>

.chat-window-dark {
  background-color : rgb(30,30,30);
}
.chat-window-light {
  background-color : #e5e5e5;
}

.chat-welcome {
  text-align : center;
  font-weight: bold;
  margin-top : 10px;
}

.chat-bubble {
  margin : 5px;
  padding : 5px;
  border-radius: 10px;
  border: 1px solid black;
  width: fit-content;
}

.chat-other-dark {
  text-align : left;
  font-weight : normal;
  background-color: rgb(59,59,61);
  color : white;
}

.chat-last-dark {
  background-color: #7a7a80;
}

.chat-me-dark {
  text-align : right;
  background-color: rgb(66,131,247);
  color : white;
  margin-left: auto;
  margin-right: 0;
  font-weight: normal;
}

.chat-other-light {
  text-align : left;
  font-weight : normal;
  background-color: rgb(233,233,235);
  color : rgb(36,36,36);
}

.chat-me-light {
  text-align : right;
  background-color: rgb(54,122,246);
  color : white;
  margin-left: auto;
  margin-right: 0;
  font-weight: normal;
}

.item {
  margin:5px auto;
}

.invisible-bottom-element {
  visibility : hidden;
  height : 1.2rem;
  margin : 10px;
}

.custom-resize-class {
  width : 100px;
  height : 100px;
}

</style>
